// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pj-picker {
  background-color: #ffffff;
  border: 1px solid black;
  border-radius: 0.3rem;
  overflow-y: auto;
  min-height: 50vh;
  height: 50vh;
  overflow-y: scroll;
}`, "",{"version":3,"sources":["webpack://./src/Screens/Step5/Step5.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;EACF,uBAAA;EACA,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;AACF","sourcesContent":[".pj-picker{\n    background-color: #ffffff;\n  border: 1px solid black;\n  border-radius: 0.3rem;\n  overflow-y: auto;\n  min-height: 50vh;\n  height: 50vh;\n  overflow-y: scroll;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
